import { render, staticRenderFns } from "./CustomPage.vue?vue&type=template&id=3d470526"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports